<template>
  <div class="list-page">
    <div class="state-tab" v-if="showState">
      <span
          v-for="(tabItem, index) in tabStateList"
          :key="index"
          :class="{actived: curState === tabItem.state}"
          @click="onClickTab(tabItem.state)"
      >{{tabItem.label}}</span>
    </div>
    <div class="list-box" v-loading="loading">
      <CardList :list="list">
        <component
            slot-scope="{ data }"
            :jobInfo="data"
            @updateDate="getData"
            :is="componentName">
        </component>
      </CardList>
      <div class="empty" v-if="showEmpty">
        <img src="../assets/images/tips.png" alt="">
        <p>童鞋，暂时没有内容哟～</p>
      </div>
    </div>
    <div class="pagination" v-if="showPage">
      <el-pagination
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :total="page.totalRow"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import JobCard from "../components/JobCard";
  import CardList from "../components/CardList";

  @Component({
    components: {
      JobCard,
      CardList
    }
  })
  export default class List extends Vue {
    list = []
    page = {}
    pageSize = 10
    loading = false
    options = {}
    componentName
    showState = false
    curState = "ALL"

    tabStateList = [
      {
        label: "全部",
        state: "ALL"
      },
      {
        label: "未处理",
        state: "WAITING"
      },
      {
        label: "内推圈已推荐",
        state: "PLATFORMFILTERPASS"
      },
      {
        label: "企业筛选通过",
        state: "COMPANYFILTERPASS"
      },
      {
        label: "面试通过",
        state: "INTERVIEWPASS"
      },
      {
        label: "不合适",
        state: "INAPPROPRIATE"
      }
    ]

    pageConfig = {
      pageSize: 10,
      pageIndex: 1,
    }

    get showPage() {
      const { totalRow } = this.page;
      return totalRow > this.pageSize;
    }

    get showEmpty() {
      const { totalRow } = this.page;
      return !totalRow && !this.loading;
    }

    onClickTab(state) {
      this.curState = state;
      const query = Object.assign({}, this.$getFromCache());
      query.state = state;
      query.pageIndex = 1;
      this.pageConfig.pageIndex = 1;
      this.$setFromCache(query);
      this.getData()
    }

    async getData() {

      const query = Object.assign({}, this.pageConfig, this.$getFromCache());
      this.loading = true;
      const res = await this.$axios({
        ...this.options,
        params: {
          ...query,
        }
      });
      this.loading = false;
      if (res.code === 200) {
        this.list = res.data;
        this.page = res.pagination || {};
      } else {
        this.$message({type: 'error', message: res.message});
      }
    }

    // 分页
    changePage(curPage) {
      const query = Object.assign({}, this.$getFromCache());
      query.pageIndex = curPage;
      this.pageConfig.pageIndex = curPage;
      this.$setFromCache(query);
      this.getData(curPage)
    }

    created () {
      const query = Object.assign({}, this.pageConfig, this.$getFromCache());
      this.$setFromCache(query);
      this.getData();
    }
  }
</script>

<style lang="scss" scoped>
  .list-page {
    .list-box {
      min-height: 600px;
      background-color: #ffffff;
      padding: 0 20px;
      margin-bottom: 20px;
    }
    .empty {
      text-align: center;
      padding-top: 200px;
      color: #666666;
    }
    .state-tab {
      background-color: #ffffff;
      padding: 10px 20px;
      border-bottom: 1px solid #f5f5f5;
      span {
        margin-right: 40px;
        display: inline-block;
        cursor: pointer;
        position: relative;
        color: #287CF3;

        &.actived{
          color: #246FD9;
          font-weight: 600;
          &::after{
          content: "";
          display: inline-block;
          background-color: #246FD9;
          height: 2px;
          width: 100%;
          position: absolute;
          bottom: -10px;
          left: 0;
        }
        }
       
      }
    }
  }
</style>
